// Aquí están los thunks relacionados con el registro de usuarios
import { createAsyncThunk } from "@reduxjs/toolkit";
import store from "@/app/store";
import api from "@/services/api";
import { userSuccess, userFailure, userReset } from "./userSlice";
import { updateImgPerfilUser, updateUserBasicInfo } from "../auth/authSlice";

/**
 * 📝 USER — Envía datos de registro al backend
 */
export const getUserInfo = createAsyncThunk(
  "user/getUserInfo",
  async ({ uid }, { dispatch, rejectWithValue }) => {
    try {
      if (!uid) {
        throw new Error("UID de usuario no disponible");
      }
      const { data } = await api.get(`/usuarios/${uid}`);
      dispatch(userSuccess({ info: data }));
      return data;
    } catch (err) {
      console.error("Error al obtener información del usuario:", err);
      dispatch(
        userFailure(
          err.response?.data ||
            err.response?.data?.message ||
            "Error de usuario"
        )
      );
      return rejectWithValue(
        err.response?.data || err.response?.data?.message || "Error de usuario"
      );
    }
  }
);

/**
 * 📝 USER — Actualizar datos del usuario
*/

export const updateImgPerfil = createAsyncThunk(
  "user/updateImgPerfil",
  async (
    {
      imageFile, // Ahora esperamos un File object en lugar de base64
    },
    { dispatch, rejectWithValue }
  ) => {
    console.log("Iniciando actualización de Imagen de Perfil...");
    console.log({ imageFile });
    try {
      const state = store.getState();
      const userId = state.auth.user?.uid;
      const info = state.user.info;
      if (!userId) {
        throw new Error("ID de usuario no disponible");
      }
      // Crear FormData para enviar el archivo
      const formData = new FormData();
      formData.append("imgPerfil", imageFile);

      // Hacer la petición PUT con FormData
      const { data } = await api.put(`/usuarios/${userId}/imagen`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      dispatch(
        userSuccess({ info: { ...info, imgPerfil: data.imgPerfilUrl } })
      );
      // debugger;
      dispatch(updateImgPerfilUser({ imgPerfil: data.imgPerfilUrl }));
      console.log("Actualización de Imagen de Perfil exitosa:", data);
      return data;
    } catch (err) {
      console.error("Error al actualizar Imagen de Perfil:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Error al actualizar Imagen de Perfil";
      dispatch(userFailure(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);

/** *
 * 📝 USER — Actualizar imagen de portada del usuario
*/

export const updateImgPortada = createAsyncThunk(
  "user/updateImgPortada",
  async (
    {
      imageFile, // Ahora esperamos un File object en lugar de base64
    },
    { dispatch, rejectWithValue }
  ) => {
    console.log("Iniciando actualización de Imagen de Portada...");
    console.log({ imageFile });
    try {
      const state = store.getState();
      const userId = state.auth.user?.uid;
      const info = state.user.info;
      if (!userId) {
        throw new Error("ID de usuario no disponible");
      }
      // Crear FormData para enviar el archivo
      const formData = new FormData();
      formData.append("imgPortada", imageFile);

      // Hacer la petición PUT con FormData
      const { data } = await api.put(`/usuarios/${userId}/portada`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Información de usuario actualizada:", {
        ...info,
        imgPortada: data.imgPortadaUrl,
      });
      dispatch(
        userSuccess({ info: { ...info, imgPortada: data.imgPortadaUrl } })
      );
      // debugger;
      console.log("Actualización de Imagen de Portada exitosa:", data);
      return data;
    } catch (err) {
      console.error("Error al actualizar Imagen de Portada:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Error al actualizar Imagen de Portada";
      dispatch(userFailure(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);

/** * 📝 USER — Obtener mis empresas
 */

export const getMisEmpresas = createAsyncThunk(
  "user/getMisEmpresas",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const state = store.getState();
      const userId = state.auth.user?.uid;
      if (!userId) {
        throw new Error("ID de usuario no disponible");
      }
      const { data } = await api.get(`/usuarios/${userId}/empresas`);
      // debugger;
      dispatch(userSuccess({ info: { ...state.user.info, empresas: data } }));
      // debugger;
      return data;
    } catch (err) {
      console.error("Error al obtener mis empresas:", err);
      dispatch(
        userFailure(
          err.response?.data ||
            err.response?.data?.message ||
            "Error al obtener mis empresas"
        )
      );
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error al obtener mis empresas"
      );
    }
  }
);

/**
 * * 📝 USER - Obtener mis tickets comprados con filtros
 */

export const getMisTicketsComprados = createAsyncThunk(
  "user/getMisTicketsComprados",
  async (filters = {}, { dispatch, rejectWithValue }) => {
    try {
      const state = store.getState();
      const userId = state.auth.user?.uid;
      if (!userId) {
        throw new Error("ID de usuario no disponible");
      }
      
      // Construir query parameters desde los filtros
      const params = new URLSearchParams();
      
      if (filters.vigente !== undefined) {
        params.append('vigente', String(filters.vigente));
      }
      if (filters.eventoFechaHoraInicioDesde) {
        params.append('eventoFechaHoraInicioDesde', filters.eventoFechaHoraInicioDesde);
      }
      if (filters.eventoFechaHoraInicioHasta) {
        params.append('eventoFechaHoraInicioHasta', filters.eventoFechaHoraInicioHasta);
      }
      if (filters.eventoFechaHoraFinDesde) {
        params.append('eventoFechaHoraFinDesde', filters.eventoFechaHoraFinDesde);
      }
      if (filters.eventoFechaHoraFinHasta) {
        params.append('eventoFechaHoraFinHasta', filters.eventoFechaHoraFinHasta);
      }
      if (filters.fechaCompraDesde) {
        params.append('fechaCompraDesde', filters.fechaCompraDesde);
      }
      if (filters.fechaCompraHasta) {
        params.append('fechaCompraHasta', filters.fechaCompraHasta);
      }
      if (filters.sortBy) {
        params.append('sortBy', filters.sortBy);
      }
      if (filters.sortOrder) {
        params.append('sortOrder', filters.sortOrder);
      }
      if (filters.page) {
        params.append('page', String(filters.page));
      }
      if (filters.limit) {
        params.append('limit', String(filters.limit));
      }
      
      const queryString = params.toString();
      const url = queryString 
        ? `/usuarios/${userId}/tickets?${queryString}`
        : `/usuarios/${userId}/tickets`;
        
      const { data } = await api.get(url);
      dispatch(userSuccess({ info: { ...state.user.info, ticketsComprados: data } }));
      return data;
    } catch (err) {
      console.error("Error al obtener mis tickets comprados:", err);
      dispatch(
        userFailure(
          err.response?.data?.message ||
            err.response?.data ||
            "Error al obtener mis tickets comprados"
        )
      );
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data ||
          "Error al obtener mis tickets comprados"
      );
    }
  }
);

/**
 * * 📝 USER - Obtener eventos donde el usuario tiene tickets comprados (agrupados por evento)
 * Este endpoint es público y puede ser usado para ver eventos de cualquier usuario
 */

export const getEventosConTicketsDeUsuario = createAsyncThunk(
  "user/getEventosConTicketsDeUsuario",
  async ({ uid, filters = {} }, { dispatch, rejectWithValue }) => {
    try {
      if (!uid) {
        throw new Error("UID de usuario no disponible");
      }
      
      // Construir query parameters desde los filtros
      const params = new URLSearchParams();
      
      if (filters.eventoFechaHoraInicioDesde) {
        params.append('eventoFechaHoraInicioDesde', filters.eventoFechaHoraInicioDesde);
      }
      if (filters.eventoFechaHoraInicioHasta) {
        params.append('eventoFechaHoraInicioHasta', filters.eventoFechaHoraInicioHasta);
      }
      if (filters.eventoFechaHoraFinDesde) {
        params.append('eventoFechaHoraFinDesde', filters.eventoFechaHoraFinDesde);
      }
      if (filters.eventoFechaHoraFinHasta) {
        params.append('eventoFechaHoraFinHasta', filters.eventoFechaHoraFinHasta);
      }
      if (filters.sortBy) {
        params.append('sortBy', filters.sortBy);
      }
      if (filters.sortOrder) {
        params.append('sortOrder', filters.sortOrder);
      }
      if (filters.page) {
        params.append('page', String(filters.page));
      }
      if (filters.limit) {
        params.append('limit', String(filters.limit));
      }
      
      const queryString = params.toString();
      const url = queryString 
        ? `/usuarios/${uid}/eventos-con-tickets?${queryString}`
        : `/usuarios/${uid}/eventos-con-tickets`;
        
      const { data } = await api.get(url);
      return data;
    } catch (err) {
      console.error("Error al obtener eventos con tickets del usuario:", err);
      dispatch(
        userFailure(
          err.response?.data?.message ||
            err.response?.data ||
            "Error al obtener eventos con tickets"
        )
      );
      return rejectWithValue(
        err.response?.data?.message ||
          err.response?.data ||
          "Error al obtener eventos con tickets"
      );
    }
  }
); 

/** *
 * 📝 USER — Obtener detalle de un ticket comprado
*/

export const getDetalleTicketComprado = createAsyncThunk(
  "user/getDetalleTicketComprado",
  async ({ idTicket }, { dispatch, rejectWithValue }) => {
    try {
      if (!idTicket) {
        throw new Error("ID de ticket no disponible");
      }
      const { data } = await api.get(`/tickets/${idTicket}`);
      dispatch(userSuccess({ ticketDetalle: data }));
      return data;
    } catch (err) {
      console.error("Error al obtener detalle del ticket:", err);
      
      const errorMessage = err.response?.data?.message ||
        err.response?.data ||
        "Error al obtener detalle del ticket";
      const errorStatus = err.response?.status || null;
      
      dispatch(
        userFailure({
          message: errorMessage,
          status: errorStatus
        })
      );
      
      return rejectWithValue({
        message: errorMessage,
        status: errorStatus
      });
    }
  }
);

/** *
 * 📝 USER — Actualizar información de Perfil
*/

export const updateInfoUserProfile = createAsyncThunk(
  "user/updateInfoUserProfile",
  async (
    {
      nombre,
      apellido,
      alias,
      numeroTributario,
      correo,
      telefono,
      fechaNacimiento,
      genero,
      facebook,
      instagram,
      tiktok,
      spotify,
      pais,
      ciudad,
      comuna,
    },
    { dispatch, rejectWithValue }
  ) => {
    console.log("Iniciando actualización de información de perfil...");
    try {
      const state = store.getState();
      const userId = state.auth.user?.uid;
      if (!userId) {
        throw new Error("ID de usuario no disponible");
      }

      // Hacer la petición PUT con los datos del formulario
      const { data } = await api.put(`/usuarios/${userId}`, {
        nombre,
        apellido,
        alias,
        numeroTributario,
        correo,
        telefono,
        fechaNacimiento,
        genero,
        facebook,
        instagram,
        tiktok,
        spotify,
        pais,
        ciudad,
        comuna,
      });

      // Actualizar el estado con la nueva información
      const updatedInfo = {
        ...state.user.info,
        ...data.usuario,
      };
      
      dispatch(userSuccess({ info: updatedInfo }));
      
      // Actualizar también el estado de auth persistente con los datos básicos
      dispatch(updateUserBasicInfo({
        nombre: data.usuario.nombre,
        apellido: data.usuario.apellido,
        correo: data.usuario.correo,
        numeroTributario: data.usuario.numeroTributario,
      }));
      
      console.log("Actualización de información de perfil exitosa:", data);
      return data;
    } catch (err) {
      console.error("Error al actualizar información de perfil:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Error al actualizar información de perfil";
      dispatch(userFailure(errorMessage));
      return rejectWithValue(errorMessage);
    }
  }
);

/**
 * 📝 USER — Obtener usuarios para transferir ticket
 */
export const getUsuariosParaTransferir = createAsyncThunk(
  "user/getUsuariosParaTransferir",
  async ({ buscarPor = 'todas', busqueda = '', page = 1, limit = 9, datos = 'uid,imgPerfil,nombre,apellido,alias' }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      
      if (datos) params.append('datos', datos);
      if (buscarPor) params.append('buscarPor', buscarPor);
      if (busqueda) params.append('busqueda', busqueda);
      if (page) params.append('page', String(page));
      if (limit) params.append('limit', String(limit));
      
      const { data } = await api.get(`/usuarios?${params.toString()}`);
      
      return data;
    } catch (err) {
      console.error("Error al obtener usuarios para transferir:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Error al obtener usuarios";
      return rejectWithValue(errorMessage);
    }
  }
);

/**
 * 📝 USER — Transferir ticket a otro usuario
 */
export const transferirTicket = createAsyncThunk(
  "user/transferirTicket",
  async ({ uidDestinatario, uidTicket }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await api.post(
        `/usuarios/${uidDestinatario}/transferir-ticket`,
        { uidTicket }
      );
      
      // Limpiar cache de tickets del usuario actual
      dispatch(userSuccess({ info: { ticketsComprados: null } }));
      
      console.log("Transferencia de ticket exitosa:", data);
      return data;
    } catch (err) {
      console.error("Error al transferir ticket:", err);
      
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Error al transferir ticket";
      const errorStatus = err.response?.status || null;
      
      return rejectWithValue({
        message: errorMessage,
        status: errorStatus
      });
    }
  }
);

/**
 * 📝 USER — Obtener links de referido públicos de un usuario específico
 */
export const getReferralLinksDeUsuario = createAsyncThunk(
  'user/getReferralLinksDeUsuario',
  async ({ uid, filters = {} }, { rejectWithValue }) => {
    try {
      // Construir query params
      const params = new URLSearchParams();
      
      if (filters.eventoFechaHoraInicioDesde) params.append('eventoFechaHoraInicioDesde', filters.eventoFechaHoraInicioDesde);
      if (filters.eventoFechaHoraInicioHasta) params.append('eventoFechaHoraInicioHasta', filters.eventoFechaHoraInicioHasta);
      if (filters.eventoFechaHoraFinDesde) params.append('eventoFechaHoraFinDesde', filters.eventoFechaHoraFinDesde);
      if (filters.eventoFechaHoraFinHasta) params.append('eventoFechaHoraFinHasta', filters.eventoFechaHoraFinHasta);
      if (filters.eventoEstado) params.append('eventoEstado', filters.eventoEstado);
      if (filters.sortBy) params.append('sortBy', filters.sortBy);
      if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);

      const queryString = params.toString();
      const url = `/usuarios/${uid}/referral-links${queryString ? '?' + queryString : ''}`;

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo links de referido del usuario:', error);
      return rejectWithValue(error.response?.data || { message: 'Error obteniendo links de referido' });
    }
  }
);
